import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function SafeDrivingNavigationUpdateBottomSheetKr() {
  const {t} = useInferableTranslation();

  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T20124')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label="닫기"
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{t('T20173')}</strong>
          <ul className="bottom_sheet_list">
            <li className="bottom_sheet_item">{t('T20174')}</li>
          </ul>
        </div>

        <div className="bottom_sheet_footer">
          <button
            type="button"
            className="btn btn_large btn_filled"
          >
            {t('T30154')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SafeDrivingNavigationUpdateBottomSheetKr;
